import type { TFunction } from 'i18next';

import { getValidations } from '@app/dashboard/views/pages/inner_layout/Reach/utils/create-campaign';

export const CREATE_CAMPAIGN_FIELDS = {
  SENDER_NAME: 'sender_name',
  TITLE: 'title',
  MOBILE_NUMBERS: 'mobile_numbers',
  DESCRIPTION: 'description',
  CONTENT: 'content',
  DATE: 'date',
  TIME: 'time',
} as const;

const BASE_FIELDS_DATA = { value: '', isValid: undefined, errorMsg: '' };

export const INITIAL_ADD_EDIT_FIELDS_STATE = (t: TFunction) => ({
  [CREATE_CAMPAIGN_FIELDS.TITLE]: {
    ...BASE_FIELDS_DATA,
    validations: getValidations(t)[CREATE_CAMPAIGN_FIELDS.TITLE],
  },
  [CREATE_CAMPAIGN_FIELDS.DESCRIPTION]: {
    ...BASE_FIELDS_DATA,
    validations: getValidations(t)[CREATE_CAMPAIGN_FIELDS.DESCRIPTION],
  },
  [CREATE_CAMPAIGN_FIELDS.CONTENT]: {
    ...BASE_FIELDS_DATA,
    validations: getValidations(t)[CREATE_CAMPAIGN_FIELDS.CONTENT],
  },
  [CREATE_CAMPAIGN_FIELDS.DATE]: {
    ...BASE_FIELDS_DATA,
    validations: getValidations(t)[CREATE_CAMPAIGN_FIELDS.DATE],
  },
  [CREATE_CAMPAIGN_FIELDS.TIME]: {
    ...BASE_FIELDS_DATA,
    validations: getValidations(t)[CREATE_CAMPAIGN_FIELDS.TIME],
  },
  [CREATE_CAMPAIGN_FIELDS.MOBILE_NUMBERS]: {
    ...BASE_FIELDS_DATA,
    value: {
      index: 4,
      name: 'custom',
      start: undefined,
      end: undefined,
    } as any,
    validations: getValidations(t)[CREATE_CAMPAIGN_FIELDS.MOBILE_NUMBERS],
  },
});

export const TEMPLATE_DOWNLOAD_ENDPOINT = '/reach/download_bulk_user/';
export const MAX_ROWS_IN_FILE = 100000;
export const NO_ROWS_IN_FILE = 0;
export const EGY_PHONE_REGEX = /^(12|10|11|15)\d{8}$/;

export const ENG_MESSAGE_LIMITS = [160, 306, 459, 612, 765, 918, 1071, 1224];
export const UNICODE_MESSAGE_LIMITS = [70, 134, 201, 268, 335, 402, 469, 536];
export const MESSAGE_REGEX =
  /^[\u0600-\u06FF\u0750-\u077F\uFB50-\uFBC1\uFBD3-\uFDFF\uFE70-\uFEFCa-zA-Z0-9\s.,'"`~!@#$%^&*()_\-+=[\]{}|\\:;<>?/\p{Extended_Pictographic}]+$/u;
export const REQUIRED_REGEX = /^(?!\s*$).+/;
export const PHONE_CELL = 'Number';
export const ALLOWED_FILE_TYPES = ['.csv', '.xlsx'];
export const DATE_PLACE_HOLDER = {
  EN: 'dd-mm-yyyy',
  AR: 'يوم-شهر-سنة',
};
